import React, {Suspense} from 'react';
import DashboardLeft from '../../shared/DashboardLeft';
import Header from '../../shared/Header';
import Footer from '../../shared/Footer';
import FormSale from '../form/FormSale';
import Translator from '../../translations/Translator';
import Line from '../../shared/Line';

function PageSalesForm() {
    document.title = 'Sale - zizier';
    return (
        <Suspense
            fallback={
                <p>
                    <Translator value="i18n.loading" />
                </p>
            }
        >
            <div className="row">
                <Header />
                <DashboardLeft />
                <div className="col-md-9">
                    <h5>
                        <Translator value="i18n.sale.form" />
                    </h5>
                    <Line />
                    <FormSale />
                </div>
                <Footer />
            </div>
        </Suspense>
    );
}

export default PageSalesForm;
